import type { AppDispatch, RootState } from 'src/store';
import { connect } from 'react-redux';

import { RULER } from 'src/pages/editor/components/layer/layerTypes';
import { getRulerById, getSelectedLayer } from 'src/selectors/layers';
import { updatePosition } from 'src/pages/editor/components/rulers/slice';
import { selectLayer } from 'src/pages/editor/components/layer/slice';
import rulerView from './ruler';

interface RulerStateProps {
    point1: { x: number; y: number };
    point2: { x: number; y: number };
    segments: number;
    ticks: number[];
    color: string;
    hidden?: boolean;
}

const mapStateToProps = (state: RootState, ownProps: { id: string }) => ({
    selected: getSelectedLayer(state).id === ownProps.id,
    // `getRulerById` falls back to `{}` for an id with no matching ruler, which can't actually
    // happen for how this container is used (`rulerIds` is always derived from existing rulers) --
    // asserting the real shape here instead of leaving it a loose/empty union, matching the implicit
    // assumption the untyped version always made.
    ...(getRulerById(state, ownProps.id) as RulerStateProps),
});

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: { id: string }) => ({
    selectRuler: () => dispatch(selectLayer({ id: ownProps.id, type: RULER })),
    updatePosition: (data: TODO) => dispatch(updatePosition({ id: ownProps.id, ...data })),
});

const rulerContainer = connect(mapStateToProps, mapDispatchToProps)(rulerView);

export default rulerContainer;
